var render = function render(){var _vm=this,_c=_vm._self._c;return _c('show-missing-stock-table',{attrs:{"supplier-order-id":_vm.getOrderId,"context":"supplierOrderSuggestions"},on:{"changed":function($event){return _vm.$emit('changed', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }